import { useCallback } from "react";
import Character1 from "../assets/img/wrotevote/character-head-individual-1.svg";
import Character2 from "../assets/img/wrotevote/character-head-individual-2.svg";
import Character3 from "../assets/img/wrotevote/character-head-individual-3.svg";
import Character4 from "../assets/img/wrotevote/character-head-individual-4.svg";
import Character5 from "../assets/img/wrotevote/character-head-individual-5.svg";
import Character6 from "../assets/img/wrotevote/character-head-individual-6.svg";
import Character7 from "../assets/img/wrotevote/character-head-individual-7.svg";
import { shuffle } from "../utils/Helpers";

export const useCharacters = () => {
    const allCharacters = [Character1, Character2, Character3, Character4, Character5, Character6, Character7];

    const getRandomCharacterPair = useCallback((): [string, string] => {
        const shuffled = shuffle(allCharacters);

        return [shuffled[0], shuffled[1]];
    }, [allCharacters]);

    const getRandomCharacter = useCallback((): string => {
        const shuffled = shuffle(allCharacters);

        return shuffled[0];
    }, [allCharacters]);

    const getRandomCharacters = useCallback((): string[] => {
        const shuffled = shuffle(allCharacters);

        return shuffled;
    }, [allCharacters]);

    return {
        allCharacters,
        getRandomCharacterPair,
        getRandomCharacter,
        getRandomCharacters
    }
}
